import { render, staticRenderFns } from "./ValeSidebarSendVale.vue?vue&type=template&id=50cab206&"
import script from "./ValeSidebarSendVale.vue?vue&type=script&lang=js&"
export * from "./ValeSidebarSendVale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports